import React from 'react'
import { Modal } from '@components/ui'

type MessageCenterDeleteContactGroupMemberModalProps = {
  show: boolean
  memberName: string
  onCancel: () => void
  onDelete: () => void
}

const MessageCenterDeleteContactGroupMemberModal: React.FC<
  MessageCenterDeleteContactGroupMemberModalProps
> = ({ show, memberName, onCancel, onDelete }) => {
  const name = memberName.trim() || 'this member'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title="Delete member"
      description={`Are you sure you want to delete ${name} as a member? This action can't be undone.`}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      onPrimaryClick={onDelete}
      onSecondaryClick={onCancel}
    />
  )
}

export default MessageCenterDeleteContactGroupMemberModal
